import React from 'react';
import SalesIndex from '../impact';

export default function () {
  return <SalesIndex noFixedVideo noExitIntent variant="ad" />;
}
